module.exports = __webpack_public_path__ + "img/artist-kurtistodd.f85ef93c.jpg";